import React, { memo } from 'react';
import PropTypes from 'prop-types';
import CalendarIcon from '../icons/CalendarIcon';
import { Typography } from '@vt/vt-ui';
const DateInput = memo(({ label, inputRef, onChange, ...props }) => (
  <div>
    <Typography variant='body4' className="text-left text-[#858585] mb-1">{label}</Typography>
    <div className="relative">
      <input
        ref={inputRef}
        onChange={({ target: { value } }) => onChange(value)}
        className="w-full h-[40px] rounded-md px-2 text-[#e5e5e5] bg-[#0000] border border-[#2e2e2e] text-sm focus:border-[#0FEF9E] hover:border-[#0FEF9E] outline-none"
        type="date"
        {...props}
      />
      <div
        className="absolute right-[15px] top-[12px] cursor-pointer"
        onClick={() => inputRef.current.showPicker()}>
        <CalendarIcon />
      </div>
    </div>
  </div>
));

DateInput.displayName = 'DateInput';

DateInput.propTypes = {
  label: PropTypes.string.isRequired,
  inputRef: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};

export default DateInput;
